import React from "react";
import { Field, Form } from "react-final-form";
import ValidatedInput from "../../common/ValidatedInput";
import { useErrorHandler } from "react-error-boundary";
import { useMutation } from "react-query";
import { createErrors } from "../../../queries/helpers";
import PropTypes from "prop-types";
import { updateProfile } from "../../../queries/session";

const ProfilePage = ({ currentUser, toast }) => {
  const handleError = useErrorHandler();
  const updateUser = useMutation(async (formData) => {
    await updateProfile(formData, currentUser.id);
  });

  const onSubmit = async (values) => {
    values["password_confirmation"] = values.password;
    return await updateUser
      .mutateAsync(values)
      .then(() => {
        toast.success("Your Profile updated successfully!");
      })
      .catch((error) => {
        toast.error("Failed to update your profile");
        return createErrors(
          error,
          "Failed to update your profile",
          handleError
        );
      });
  };
  return (
    <Form
      onSubmit={onSubmit}
      initialValues={currentUser}
      validate={(values) => {
        const errors = {};
        if (!values.firstName) {
          errors.legalName = "Legal Name is Required";
        }
        if (!values.lastName) {
          errors.vat = "VAT number is Required";
        }
        if (!values.email) {
          errors.email = "Email is Required";
          if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
            errors.email = "Invalid email address";
          }
        }
        return errors;
      }}
      render={({
        submitError,
        handleSubmit,
        form,
        submitting,
        pristine,
        values,
      }) => (
        <form onSubmit={handleSubmit}>
          <div className="container mw-520">
            <h3 className="mb-4">Profile settings</h3>
            {submitError && (
              <p className="text-center text-error">{submitError} </p>
            )}
            <div className="row row-xs">
              <div className="col-5">
                <Field
                  label={"First name"}
                  inputClassName="fin-control"
                  type="text"
                  name="firstName"
                  component={ValidatedInput}
                  placeholder="FirstName"
                />
              </div>
              <div className="col-7">
                <Field
                  label={"Last name"}
                  inputClassName="fin-control"
                  type="text"
                  name="lastName"
                  component={ValidatedInput}
                  placeholder="LastName"
                />
              </div>
              <div className="col-12">
                <Field
                  label={"Email"}
                  inputClassName="fin-control"
                  type="email"
                  name="email"
                  component={ValidatedInput}
                  placeholder="Email"
                />
              </div>
            </div>
            <h5 className="my-4">Change password</h5>
            <p className="mb-4">
              To change your password, first type your <em>current</em> password
              and then type your <em>new</em> password.
            </p>
            <div className="password-wrapper">
              <Field
                label={"New Password"}
                inputClassName="fin-control"
                type="text"
                name="password"
                component={ValidatedInput}
              />
            </div>
            <div className="mt-45">
              <button
                disabled={submitting || pristine}
                id="submit"
                className="btn btn-sm btn-main"
              >
                Update profile
              </button>
              <button
                type="button"
                className="btn btn-sm btn-cancel"
                onClick={form.reset}
                disabled={submitting || pristine}
              >
                Reset
              </button>
            </div>
          </div>
        </form>
      )}
    />
  );
};

ProfilePage.propTypes = {
  currentUser: PropTypes.object.isRequired,
};

export default ProfilePage;
